module.exports = __webpack_public_path__ + "static/media/background_grey.0374f114.png";